import { useQuery } from '@tanstack/react-query';
import dailySiteReportService from '@services/dailySiteReport';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';

export const DAILY_SITE_REPORT_QUERY_KEY = 'dailySiteReport';

export const useDailySiteReport = (reportId: string | undefined) => {
  const { organizationId } = useAppSelector((state: RootState) => state.organization);

  return useQuery({
    queryKey: [DAILY_SITE_REPORT_QUERY_KEY, organizationId, reportId],
    queryFn: () => dailySiteReportService.getDailySiteReport(reportId as string),
    enabled: !!organizationId && !!reportId,
    retry: false,
  });
};

export default useDailySiteReport;
